
<div >
  <div class="row ">
    <div class="col pl-3">
      <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Timesheet Verification</h4>
    </div>
  </div>
  <!--  List-->
  <div class="row mt-4"
  *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined && global.globalAgencyId!=0 && global.globalAgencyId != '' && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'; else elsecondition">
  <div class="col-12 mt-3 p-0">
    <div widget class="card border-0 box-shadow">
        <div class="card-body transparent">
            <div>
          <div class="row mt-2">
            <div class="col-lg-3">
              <div class="col-lg-12">
                <label style="font-weight:bold">From<sup class="super-script">*</sup> </label>
              </div>
              <div class="col-lg-12">
                <my-date-picker [options]="myDatePickerOptions" [selDate]="fromdate"
                id="TVFromDate"
                  (inputFieldChanged)="newdates($event,'inputchage','start')"
                  (dateChanged)="newdates($event,'datechagned','start')" placeholder="mm/dd/yyyy"></my-date-picker>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="col-lg-12">
                <label style="font-weight:bold">To<sup class="super-script">*</sup> </label>
              </div>
              <div class="col-lg-12">
                <my-date-picker [options]="myDatePickerOptions" [selDate]="todate"
                id="TVToDate"
                  (inputFieldChanged)="newdates($event,'inputchage','end')"
                  (dateChanged)="newdates($event,'datechagned','end')" placeholder="mm/dd/yyyy"></my-date-picker>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="col-lg-12">
                <label style="font-weight:bold">Show Claim Status </label>
              </div>
              <div class="col-lg-12">
                <ng-select [(ngModel)]="selectClaimStatus" [multiple]="true"  
                id="TVShowClaimStatus"
                  [disabled]="global.globalAgencyId==0" [items]="ClaimStatusList" bindLabel="Value" bindValue="Key">
                </ng-select>
              </div>
            </div>
            <!-- <div class="col-lg-3">
              <div class="col-lg-12">
                <label style="font-weight:bold">Payroll Paid</label>
              </div>
              <div class="col-lg-12">
                <ng-select [searchable]="true" [clearable]="true" [(ngModel)]="ListSendBO.isPaid"
                id="TVPayrollPaid"
                  [items]="timesheetPaidList" bindLabel="Value" bindValue="Key">
                </ng-select>
              </div>
            </div> -->
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="col-lg-12">
                <label style="font-weight:bold">Employee </label>
              </div>
              <div class="col-lg-12 d-flex">
                <ng-select [searchable]="true" [(ngModel)]="ListEmployeeFilter" [clearable]="true"
                id="TVEmployee"
                class="w-100"
                  [items]="AllEmployeeDropDownListwithStatus" bindLabel="Value" bindValue="Key">
                </ng-select>
                <app-dropdown  
                (EmitRefreshClick)="getAllEmployeeDropDown()"></app-dropdown>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-12">
                <label style="font-weight:bold">Client </label>
              </div>
              <div class="col-lg-12 d-flex">
                <ng-select    id="TVClient"[searchable]="true" [clearable]="true" [(ngModel)]="ListClientFilter"
                class="w-100"
                  [items]="AllClientDropDownListwithStatus" bindLabel="Value" bindValue="Key">
                </ng-select>
                <app-dropdown  
                (EmitRefreshClick)="getAllClient()"></app-dropdown>
              </div>
            </div>
            
          </div>

          <div class="row mt-2 pl-3">
            <div class="col-lg-8 ">
              <!-- radio -->
              <!-- <input type="radio" class="ml-2" value="All" [disabled]="global.globalAgencyId==0"
                [(ngModel)]="TimesheetApproveFilter" (change)="gettimesheetdata()"  id="TVall"> &nbsp; All
              <input type="radio" class="ml-2" value="Approve" [disabled]="global.globalAgencyId==0"
                [(ngModel)]="TimesheetApproveFilter" (change)="gettimesheetdata()"  id="TVapproved"> &nbsp;Approved
              <input type="radio" class="ml-2" value="NotApprove" [disabled]="global.globalAgencyId==0"
                [(ngModel)]="TimesheetApproveFilter" (change)="gettimesheetdata()"  id="TVnotapproved"> &nbsp; Not Approved -->

              <!-- Send to bill -->
              <!-- && fp.sendtobill -->
              <button type="button" *ngIf="!updateclaim &&  fp.sendtobill " class="btn blue-btn btn-sm marginleft"
                (click)="selecttobill()"
                [disabled]="isCheckedBool || sendToBillinProgress || global.globalAgencyId==0" id="Tvsendtobill">Send to bill</button>
              <!-- Update Claim -->
              <button type="button" *ngIf="updateclaim" class="btn blue-btn btn-sm marginleft" (click)="updateClaim()"
                [disabled]="isCheckedBool || sendToBillinProgress || global.globalAgencyId==0" id="Tvupdateclaims">Update Claim</button>
              <!-- Export as Excel -->
              <button type="button" class="btn blue-btn btn-sm marginleft" (click)="exportAsExcel('parentline')"
                [disabled]="global.globalAgencyId==0 || !isDataAvailableToPrint" id="TvExportasExcel">Export as Excel</button>
                <button type="button" class="btn blue-btn btn-sm marginleft" (click)="exportAsExcel('childline')"
                [disabled]="global.globalAgencyId==0 || !isDataAvailableToPrint" id="TvExportServiceLine">Export ServiceLine</button>
            </div>
            <div class="col-lg-4 text-right">
              <!-- Move to Archive -->
              <button type="button" *ngIf="TimesheetVerificationtab=='Active'"
                [disabled]="childTimeSheetId.length==0|| global.globalAgencyId==0" data-bs-toggle="modal"
                data-bs-target="#modalArchiveNotes" class="btn blue-btn btn-sm marginleft" id="TvMovetoArchive">
                Move to Archive
              </button>
              <!-- Move to Active -->
              <button type="button" *ngIf="TimesheetVerificationtab=='Archive'"
                [disabled]="childTimeSheetId.length==0 || global.globalAgencyId==0"
                (click)="TimeSheetVerificationActive()" class="btn blue-btn btn-sm marginleft" id="TvMovetoActive">
                Move to Active
              </button>
              <!-- Apply -->
              <button type="button" class="btn blue-btn btn-sm marginleft"
                (click)="ListSendBO.requesttype='getdata';checkBeforeApply();ApplyforupdateClaims();"
                [disabled]="global.globalAgencyId==0" id="TvApply">Apply</button>
              <!-- Refresh -->
              <button type="button" [disabled]="global.globalAgencyId==0" (click)="Refresh()"
                class="btn blue-btn btn-sm  marginleft" id="TvRefresh">
                <i class="fa fa-repeat" id="TvRefreshIcon">&nbsp;</i>Refresh
              </button>


            </div>
          </div>
          <div class="row pl-3 pr-3">
            <div class="col-lg-12 ">
              <section id="tabs" class="project-timesheetVerificationTab">
                <div class="row mt-4">
                  <div class="col-lg-12">
                    <nav>
                      <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                        <a class="nav-item nav-link active" id="nav-Active-tab" data-bs-toggle="tab" href="#nav-Active"
                          role="tab" aria-controls="nav-Active" aria-selected="true"
                          (click)="ListSendBO.requesttype='getdata';tabchanged('Active')"
                          [ngClass]="{'mytab-inactive':TimesheetVerificationtab!='Active','active':TimesheetVerificationtab=='Active'}">Active
                        </a>
                        <a class="nav-item nav-link" id="nav-Archive-tab" data-bs-toggle="tab" href="#nav-Archive"
                          role="tab" aria-controls="nav-Archive" aria-selected="false"
                          (click)="ListSendBO.requesttype='getdata';tabchanged('Archive')"
                          [ngClass]="{'mytab-inactive':TimesheetVerificationtab!='Archive','active':TimesheetVerificationtab=='Archive'}">Archive
                        </a>
                      </div>
                    </nav>
                    <!-- ---------------------------------------template for validate button------------------- -->
                    <span id="OpenModal2" data-bs-target="#showerror" data-bs-toggle="modal"></span>
                    <span id="authedit" data-bs-target="#solveerr" data-bs-toggle="modal"></span>
                    <div class="modal fade" id="showerror" tabindex="-1" role="dialog"
                      aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">

                      <div class="modal-dialog " role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <label class="font-header">Check Validation Status</label>

                            <button class="btn-close" type="button" (click)="colseerr()"></button>
                          </div>
                          <div class="modal-body">
                            <div class="container scrolltbody">
                              <div class="mb-2 row">
                                <input type="checkbox" class="mr-2 mt-1" [(ngModel)]="isEnabled"
                                  (change)="SelectErrorData()" />
                                <label for="radio-1">Show errors only</label>
                              </div>
                              <div>
                                <table class="table table-responsive table-hover table-bordered"
                                  style="margin-left: 0px">
                                  <thead>
                                    <!-- <tr> -->
                                    <th style="background: #00786a;width: 255px" class="pointer">Column</th>
                                    <th style="background: #00786a;width: 150px" class="pointer">Status</th>
                                    <!-- </tr> -->
                                  </thead>
                                  <tbody>
                                    <!-- paginate:{ id:'employee', itemsPerPage: 10, currentPage: p ,totalItems:showerrolist.length };let i=index  -->
                                    <tr *ngFor="let c of showerrolist" class="row1">

                                      <!--  -->
                                      <td style="position: relative;background-color:  whitesmoke;" *ngIf="c.color == 'Red' && 
                                      c.columnName!= 'Zero Bill'
                                      && c.columnName != 'Client_ServiceAgreementNo' 
                                      && c.columnName!='CertificateICD10_01' 
                                      && c.columnName != 'Icd10' 
                                      && c.columnName != 'StartOfCare' 
                                      && c.columnName!='EmployeePayorUMPI'
                                      && c.columnName!='ReferringProvider_FirstName'
                                      && c.columnName!='ReferringProvider_LastName'
                                      && c.columnName!='ReferringProvider_Identifier'
                                      "
                                       [style.color]="c.color"
                                        class="row1 font-weight" (click)="errmodal(c.columnName)">
                                        {{c.columnName}}</td>


                                      <td style="position: relative;background-color:  whitesmoke;"
                                        *ngIf="c.color == 'Red' 
                                         && (c.columnName == 'Client_ServiceAgreementNo' ||
                                         c.columnName=='CertificateICD10_01'||
                                         c.columnName == 'Icd10' ||
                                         c.columnName == 'StartOfCare'|| 
                                         c.columnName=='EmployeePayorUMPI' ||
                                         c.columnName =='ReferringProvider_FirstName' ||
                                         c.columnName =='ReferringProvider_LastName' ||
                                         c.columnName =='ReferringProvider_Identifier')"
                                        [style.color]="c.color" class="row1 font-weight"
                                        (click)="errmodal(c.columnName)">
                                        {{c.columnName}}</td>

                                        
                                      <td style="position: relative;background-color:  whitesmoke;"
                                        *ngIf="c.color == 'Green'" [style.color]="c.color" class="row1 font-weight">
                                        {{c.columnName}}</td>
                                      <td style="position: relative;background-color:  whitesmoke;"
                                        *ngIf=" c.color == 'Red' 
                                          && ( c.columnName== 'Zero Bill' )"
                                        [style.color]="c.color" class="row1 font-weight">{{c.columnName}}</td>
                                      <!-- <td [style.color]="c.color" class="row1 font-weight" >{{c.columnName}}</td> -->
                                      <td style="position: relative;background-color:  whitesmoke;"
                                        [style.color]="c.colr" id="{{c.columnName}}">
                                        {{c.status}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button class="btn blue-btn btn-sm  text-right" type="button" (click)="colseerr()">
                              Close</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ----------------------------------------split day button template------------------------ -->
                    <span id="OpenModal3" data-bs-target="#splitday" data-bs-toggle="modal"></span>
                    <div class="modal fade" id="splitday" tabindex="-1" role="dialog"
                      aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <label class="font-header">Split Day</label>
                            <button class="btn blue-btn btn-sm text-right" type="button"
                              (click)="SplitdayModalClose()">Close</button>
                          </div>
                          <div class="modal-body">
                            <div class="container">
                              <div class="row">
                                <div class="col-lg-12">
                                  <table class="table table-responsive table-hover table-bordered ml-0">
                                    <thead class="colr">
                                      <tr>
                                        <th class="pointer"> LineStatus
                                        </th>
                                        <th class="pointer"> ServiceDate
                                        </th>
                                        <th class="pointer text-right"> Daily Hours
                                        </th>
                                        <th class="pointer"> Procedure Code
                                        </th>
                                        <th class="pointer"> Mod
                                        </th>
                                        <th class="pointer"> Mod
                                        </th>
                                        <th class="pointer"> Mod
                                        </th>
                                        <th class="pointer text-right"> Over 275 Hours
                                        </th>
                                        <th class="pointer text-right"> Remaining Authorized Hours
                                        </th>
                                        <th class="pointer text-right"> Over Daily 16 hours
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let c of detailstime">
                                        <!-- <pre>{{c|json}}</pre> -->
                                        <td style="pointer-events: none;" class="dodgerblue" data-bs-toggle="modal"
                                          data-bs-target="#Edittimesheet" (click)="Edittimesheets(c)">
                                          {{c.serviceDate}}
                                        </td>
                                        <td style="pointer-events: none;" class="dodgerblue" data-bs-toggle="modal"
                                          data-bs-target="#Edittimesheet" (click)="Edittimesheets(c)">
                                          {{c.serviceCode}}
                                        </td>
                                        <td style="pointer-events: none;" class="dodgerblue text-right"
                                          data-bs-toggle="modal" data-bs-target="#Edittimesheet" (click)="Edittimesheets(c)">
                                          {{c.dailyHours}}
                                        </td>
                                        <td style="pointer-events: none;" class="dodgerblue" data-bs-toggle="modal"
                                          data-bs-target="#Edittimesheet" (click)="Edittimesheets(c)">
                                          {{c.procedureCode}}
                                        </td>
                                        <td style="pointer-events: none;" class="dodgerblue text-right"
                                          data-bs-toggle="modal" data-bs-target="#Edittimesheet" (click)="Edittimesheets(c)">
                                          {{c.overDaily16Hours}}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- --------------------------------------templatefor editing the split day record-------------------- -->
                    <!-- (rowDataBound)='rowDataBound($event)' -->
                    <span id="OpenModal4" data-bs-target="#Edittimesheet" data-bs-toggle="modal"></span>
                    <div class="modal fade" id="Edittimesheet" tabindex="-1" role="dialog"
                      aria-labelledby="exampleModalLabel" aria-hidden="true">

                      <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <label class="font-header">Update record</label>
                            <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
                          </div>
                          <div class="modal-body">
                            <div class="container">
                              <div class="col-lg-12 mt-1">
                                <div class="row">
                                  <div class="col-lg-6">
                                    <div class="row">
                                      <div class="col">
                                        <label class="font-weight">Line Status</label>
                                      </div>
                                      <div class="col">
                                        <input type=text class="form-control" [disabled]="true"
                                          [(ngModel)]="lineStatus" />
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-lg-6">
                                    <div class="row">
                                      <div class="col">
                                        <label class="font-weight">Service Date</label>
                                      </div>
                                      <div class="col">
                                        <my-date-picker [options]="myDatePickerOptions" [selDate]="serviceDate"
                                          placeholder="mm/dd/yyyy"
                                          (inputFieldChanged)="newdates($event,'inputchage','serviceDate')"
                                          (dateChanged)="newdates($event,'datechagned','serviceDate')">
                                        </my-date-picker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-12 mt-1">
                                <div class="row">
                                  <div class="col-lg-6">
                                    <div class="row">
                                      <div class="col">
                                        <label class="font-weight">Daily Hours</label>
                                      </div>
                                      <div class="col">
                                        <input type=text class="form-control" [disabled]="true"
                                          [(ngModel)]="dailyHours" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-lg-6">
                                    <div class="row">
                                      <div class="col">
                                        <label class="font-weight">Procedure Code</label>
                                      </div>
                                      <div class="col">

                                        <select class="form-control" [(ngModel)]="procedureCode">
                                          <option [value]=st.Key *ngFor="let st of Allservice">{{st.Value}}</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-lg-12 mt-1">
                                <div class="row">
                                  <div class="col-lg-6">
                                    <div class="row">
                                      <div class="col">
                                        <label class="font-weight">Over 275 hours</label>
                                      </div>
                                      <div class="col">
                                        <input type=text class="form-control" [disabled]="true"
                                          [(ngModel)]="over275Hrs" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-lg-6">
                                    <div class="row">
                                      <div class="col">
                                        <label class="font-weight">Daily over 16 hours</label>
                                      </div>
                                      <div class="col">
                                        <input type=text class="form-control" [disabled]="true" width="30%"
                                          [(ngModel)]="overDaily16Hours" />
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                              <div class="col-lg-12 mt-1">
                                <div class="row">

                                  <div class="col-lg-6">
                                    <div class="row">
                                      <div class="col-lg-6">
                                        <label class="font-weight">Remaining Authorized Hours</label>
                                      </div>
                                      <div class="col-lg-6">
                                        <input type=text class="form-control" [disabled]="true" width="50%"
                                          [(ngModel)]="remaimimgAuthorizedHours" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="modal-footer">

                            <div class="row w-100">
                              <span style="color: red;" class="w-75">Note:Only Procedure code and Service date are
                                editable</span>
                              <button class="btn blue-btn btn-sm  text-right" type="button" (click)="save()">Update &
                                Close</button>&nbsp;&nbsp;
                              <button class="btn blue-btn btn-sm  text-right" type="button"
                                data-bs-dismiss="modal">Close</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tab-content" id="nav-tabContent">
                      <div class="control-section mt-1" *ngIf="global.globalAgencyId!=0">
                        <div>
                          <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update timesheetVerificationTotalColumns constant in timesheetverification.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'TimesheetVerificationGrid' maps to localStorage key 'gridTimesheetVerificationGrid'
                                                                          -->
                          <ejs-grid #grid id='TimesheetVerificationGrid' [allowResizing]='true' 
                            [allowReordering]="true" 
                            [enablePersistence]="true"
                            [allowReordering]="true" [dataSource]='data | async' (checkBoxChange)="show1($event)"
                            (queryCellInfo)='validatebutton($event)' allowPaging='true' [allowFiltering]='true'
                            [allowSorting]='true' [pageSettings]='initialPage' (toolbarclick)="getdata($event)"
                            (dataSourceChanged)='dataSourceChanged($event)'
                            (recordDoubleClick)="recordDoubleClick($event)" [filterSettings]='filterOptions'
                            (dataStateChange)='dataStateChange($event)' [selectionSettings]='selectionOptions'
                            (cellEdit)="cellEdit($event)" [editSettings]='editSettings' (resizeStop)="onResize($event)"
                            [childGrid]='childGrid' (actionComplete)="onActionComplete($event)"
                            [showColumnChooser]='true' [textWrapSettings]='wrapSettings'>

                            <e-columns>

                              <e-column type='checkbox' [showInColumnChooser]='false' uid="checkbox" width=50
                                textAlign='center' [allowEditing]='true' editType="booleanedit" [edit]='checkparams'>
                              </e-column>

                              <e-column field='claimStatus' headerText="Claim Status" width=120 textAlign='right'
                                [allowEditing]='false' type='string' [allowSorting]='false' [allowFiltering]="false">
                                <ng-template #filterTemplate let-data>
                                  <ejs-dropdownlist id='dropdown' placeholder='Select a  Claim Status'
                                    [dataSource]='dropdata' [popupHeight]='height'>
                                  </ejs-dropdownlist>
                                </ng-template>
                              </e-column>



                              <e-column field='validate' headerText="Validate" width=100 textAlign='center'
                                [allowEditing]='false' [allowFiltering]="false" [allowSorting]='false'>
                                <ng-template #template let-data>
                                  <div>
                                    <button class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#showerror"
                                      (click)="showerrors($event)">Validate</button>
                                  </div>
                                </ng-template>
                              </e-column>
                              <e-column field='isApproved' headerText="Approve" width=90 textAlign='center'
                                [allowEditing]='false' [allowSorting]='false' [allowFiltering]='false'>
                                <ng-template #template let-data>

                                  <input type="checkbox" [(ngModel)]="data.isApproved" disabled>
                                </ng-template>
                              </e-column>

                              <e-column field='errorNotes' headerText="Error Notes" width=90 textAlign='center'
                                [allowEditing]='false' type='string' [allowSorting]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <!-- <e-column width=100 headerText='Action' uid="action" [showInColumnChooser]='false'>
                                <ng-template #template let-data>
                                  <button class="btn btn-edit-table Ationsubbtn" data-bs-target="#EditClientEmployee"
                                    data-bs-toggle="modal" (click)="edittimesheet(data,$event)"><i
                                      class="fa fa-edit"></i></button>
                                </ng-template>
                              </e-column> -->
                              <e-column field='clientName' headerText="Client" width=160 textAlign='left'
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column field='client_InsuranceNo' headerText="Insured ID" textAlign='left' width=100
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column field='payorName' headerText="Payer" textAlign='left' width=100
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>

                              <e-column field='billingpayorID' headerText="Payor ID" width=100 textAlign='left'
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>

                              <e-column field='employee' headerText="Employee" width=130 textAlign='left'
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column field='employee_UMPI' headerText="UMPI" width=120 textAlign='left'
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column width=100 uid="archieveNotes" headerText="Reason" type='string'>
                                <ng-template #template let-data>
                                  <button
                                    *ngIf="data.archieveNotes!=null &&data.archieveNotes!=undefined && data.archieveNotes!='' "
                                    class="btn btn-edit-table text-center" data-bs-toggle="modal" data-bs-target="#shownotes"
                                    (click)="shownotesdescription(data.archieveNotes)">Reason</button>&nbsp;
                                </ng-template>
                              </e-column>

                              <e-column field='serviceCode' headerText="Service Code" width=90 textAlign='center'
                                [allowEditing]='false' type='string' [allowSorting]='false'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column field='fromDate' headerText="From Date" width=130 textAlign='left'
                                [format]='formatOptions' [allowEditing]='false' type='date' [allowFiltering]='false'>
                              </e-column>
                              <e-column field='toDate' headerText="To Date" width=130 textAlign='left'
                                [format]='formatOptions' [allowEditing]='false' [allowFiltering]='false' type='date'>
                              </e-column>
                              <e-column field='totalHours' headerText="Total Hours" width=130 textAlign='right'
                                [allowEditing]='false' type='number'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>

                              <e-column field='units' headerText="Units" width=130 textAlign='right'
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column field='totalAmountExpected' headerText="Net Charge" width=130
                                textAlign='right' [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>
                              <e-column field='totalAmountBIlled' headerText="Gross Charge" width=130
                                textAlign='right' [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                              </e-column>

                              <e-column field='clientLocation' headerText="Client Location" Width=90 textAlign='center'
                                [allowEditing]='false' type='string' [allowSorting]='false' [allowFiltering]="false">
                              </e-column>
                              <e-column field='employeeLocation' headerText="Employee Location" Width=90
                                textAlign='center' [allowEditing]='false' type='string' [allowSorting]='false'
                                [allowFiltering]="false">
                              </e-column>
                              <e-column field='isPaid' headerText="Paid Payroll" width=90
                              textAlign='center' [allowEditing]='false' type='string' [allowSorting]='false'
                              [allowFiltering]="false">
                            </e-column>
                              
                              <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                  <div class="d-none d-lg-block">
                                    <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                      </i></span>
                                  </div>
                                </ng-template>
                              </e-column>

                            </e-columns>
                          </ejs-grid>
                           <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update timesheetVerificationTotalColumns constant in timesheetverification.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'TimesheetVerificationGrid' maps to localStorage key 'gridTimesheetVerificationGrid'
                                                                          -->
                          <div *ngIf="TimesheetVerificationDataList.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                          </div>
                        </div>
                        <!-- ------------------------------------template for childgrid------------------------------- -->
                        <ng-template #childtemplate let-data>
                          <div>
                            <!-- <button class="btn btn-edit-table ml-3" style="height: 24px"
                              (click)="getupdatetimesheet($event,data)" data-bs-toggle="modal"
                              data-bs-target="#updateTimesheet"><i class="fa fa-edit"></i>
                            </button> -->
                          </div>
                        </ng-template>
                        <ng-template #checkboxtemplate let-data>
                          <div>
                            <input type="checkbox" class="ml-3" [(ngModel)]="data.isApproved" disabled />
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
  <ng-template #elsecondition>
    <div class="row mt-4 ">
      <div class="col ">
        <div widget class="card border-0 box-shadow">
          <div class="card-body  widget-body pt-2">
            <div class="text-center text-danger">
              <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to
                view
                details</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<!-- ////////////////////////Error edt modal/////////////////////////// -->
<span id="OpenModal1" data-bs-target="#solveerr" data-bs-toggle="modal"></span>
<div class="modal fade " id="solveerr" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ErrModalclientAuth.length!=0">Update Client
          Authorization</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ErrModalClient.length!=0">Update Client</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ErrModalCompany.length!=0">Update Company</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ErrModalGrouppayor.length!=0">Update
          Grouppayor</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ErrModalGrouppayorService.length!=0">Update
          Grouppayorservice</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ErrModalIcd10.length!=0">Update Client
          Certification</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ErrModalemployee.length!=0">Update Employee
        </h5>
        <button type="button" class="btn-close" data (click)="closeerromodal()"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="ErrModalClient.length != 0">
          <div class="row" *ngFor="let c of ErrModalClient ; let i = index">
            <div class="col">
              <div class="row">
                <div class="col-lg-5">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;">{{c.columnName}}
                  </label>
                </div>
                <div class="col-lg-7 d-inline-flex">
                  <div *ngIf="c.columnName == 'Client_Gender'">
                    <select [ngModelOptions]="{standalone: true}" [(ngModel)]="c.columnName_i"
                      class="form-control w-100" name="genderLid" [ngModelOptions]="{standalone: true}">
                      <option [ngValue]=gen.id *ngFor="let gen of genderList">{{gen.lovName}}</option>
                    </select>
                    <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('GENDER')"></app-dropdown>
                  </div>

                  <select class="form-control" *ngIf=" c.columnName == 'Client_State' " [(ngModel)]="c.columnName_i">
                    <option [value]=""></option>
                    <option [value]=i.abbreviation *ngFor="let i of stateList">{{i.name}}</option>
                  </select>
                  <input *ngIf="c.columnName != 'Client_Gender' &&  c.columnName != 'Client_State'" type="text"
                    class="form-control" [(ngModel)]="c.columnName_i" required>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="ErrModalclientAuth.length != 0">
          <div class="row" *ngFor="let c of ErrModalclientAuth ; let i = index">
            <div class="col">
              <div class="row">
                <div class="col-lg-5">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;">{{c.columnName}}
                  </label>
                </div>
                <div class="col-lg-7">
                  <input type="text" class="form-control" [(ngModel)]="c.columnName_i" required>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="ErrModalemployee.length != 0">
          <div class="row" *ngFor="let c of ErrModalemployee ; let i = index">
            <div class="col">
              <div class="row">
                <div class="col-lg-5 pr-0">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;">{{c.columnName}}
                  </label>
                </div>
                <div class="col-lg-7">
                  <input type="text" class="form-control" [(ngModel)]="c.columnName_i" (change)="valuechange()"
                    minlength=10 maxlength=10 required>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="ErrModalCompany.length != 0">
          <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr" role="alert">
            <p>kindly assign company to the payor {{payrname}} in group payor</p>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr= false">
              <span aria-hidden="true"></span>
            </button>
          </div>
          <div class="row" *ngFor="let c of ErrModalCompany ; let i = index">
            <div class="col">
              <div class="row">
                <div class="col-lg-5">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;">{{c.columnName}}
                  </label>
                </div>
                <div class="col-lg-7">
                  <select class="form-control" *ngIf=" c.columnName == 'Company_Billto_State' "
                    [(ngModel)]="c.columnName_i">
                    <option [value]=""></option>
                    <option [value]=i.abbreviation *ngFor="let i of stateList">{{i.name}}</option>
                  </select>
                  <input *ngIf=" c.columnName!= 'Company_Billto_State' " type="text" class="form-control"
                    [(ngModel)]="c.columnName_i" required>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="ErrModalGrouppayor.length != 0">
          <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr" role="alert">
            <p>kindly assign company to the payor {{payrname}} in group payor</p>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr= false">
              <span aria-hidden="true"></span>
            </button>
          </div>
          <div class="row" *ngFor="let c of ErrModalGrouppayor ; let i = index">
            <div class="col" *ngIf="c.columnName == 'GroupPayorId'  || c.columnName == 'Group' ">
              <div class="row">
                <div class="col-lg-6">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;"
                    [(ngModel)]="c.columnName">Group </label>
                </div>
                <div class="col-lg-6 d-inline-flex">
                  <select class="form-control" [(ngModel)]="c.columnName_i">
                    <option [value]=""></option>
                    <option [ngValue]=i.id *ngFor="let i of GroupPayorlist">{{i.lovName}}</option>
                  </select>
                  <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('GROUP')"></app-dropdown>
                </div>
              </div>
            </div>
            <div class="col" *ngIf="c.columnName != 'GroupPayorId' ">
              <div class="row">
                <div class="col-lg-6">
                  <label *ngIf="c.columnName != 'CompanyId' "
                    style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;">{{c.columnName}}
                  </label>
                </div>
                <div class="col-lg-6">
                  <div *ngIf="c.columnName  == 'I837PInsTypeLid' " class="d-flex">
                    <select class="form-control" [(ngModel)]="c.columnName_i" name="InsID">
                      <option [value]=""></option>
                      <option [ngValue]=i.id *ngFor="let i of I837">{{i.lovName}}</option>
                    </select>
                    <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('I837')"></app-dropdown>
                  </div>

                  <select class="form-control"
                    *ngIf="c.columnName == 'Payor_State'  || c.columnName == 'Company_Billto_State' "
                    [(ngModel)]="c.columnName_i">
                    <option [value]=""></option>
                    <option [value]=i.abbreviation *ngFor="let i of stateList">{{i.name}}</option>
                  </select>

                  <input *ngIf="c.columnName  != 'I837PInsTypeLid' && c.columnName  != 'Group' &&c.columnName != 'CompanyId' 
                    &&c.columnName != 'Payor_State'  && c.columnName != 'Company_Billto_State'" type="text"
                    class="form-control" [(ngModel)]="c.columnName_i" required>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="ErrModalGrouppayorService.length != 0">
          <div class="row" *ngFor="let c of ErrModalGrouppayorService ; let i = index">
            <div class="col" *ngIf="c.columnName == 'GroupPayorServiceId' ">
              <div class="row">
                <div class="col-lg-6">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;"
                    [(ngModel)]="c.columnName">Group </label>
                </div>
                <div class="col-lg-6 d-inline-flex">
                  <select class="form-control" [(ngModel)]="grouplid" (ngModelChange)="groupchange(grouplid)">
                    <option [value]=""></option>
                    <option [ngValue]=i.id *ngFor="let i of GroupPayorlist">{{i.lovName}}</option>
                  </select>
                  <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('GROUP')"></app-dropdown>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;"
                    [(ngModel)]="Payor">Payor </label>
                </div>
                <div class="col-lg-6">
                  <select class="form-control" [(ngModel)]="c.columnName_payor">
                    <option [value]=""></option>
                    <option [value]=i.value *ngFor="let i of payorListgroup">{{i.label}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;"
                    [(ngModel)]="Service">Service </label>
                </div>
                <div class="col-lg-6">
                  <select class="form-control" [(ngModel)]="c.columnName_service">
                    <option [value]=""></option>
                    <option [value]=i.Key *ngFor="let i of Allservice">{{i.Value}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col" *ngIf="c.columnName != 'GroupPayorServiceId' ">
              <div class="row">
                <div class="col-lg-6">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;">{{c.columnName}}
                  </label>
                </div>
                <div class="col-lg-6">
                  <input type="text" class="form-control" *ngIf="c.columnName != 'BillingUnit' "
                    [(ngModel)]="c.columnName_i" required>
                  <div *ngIf="c.columnName == 'BillingUnit' " class="d-flex">
                    <select class="form-control" [(ngModel)]="c.columnName_i">
                      <option [value]=""></option>
                      <option [ngValue]=i.id *ngFor="let i of billingUnit">{{i.lovName}}</option>
                    </select>
                    <app-dropdown (EmitRefreshClick)="refreshToGetDropDownValues('BILLING')"></app-dropdown>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="ErrModalIcd10.length != 0">
          <div class="row" *ngFor="let c of ErrModalIcd10 ; let i = index">
            <div class="col">
              <div class="row">
                <div class="col-lg-3">
                  <label style="padding-top:9px;font-weight: 600;font-size: 13px;font-weight: bolder;">{{c.columnName}}
                  </label>
                </div>
                <div class="col-lg-9">
                  <input type="text" class="form-control" [(ngModel)]="c.columnName_i" required>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn" type="button" (click)="updatemodal()">Update</button>
        <button class="btn blue-btn" type="button" (click)="closeerromodal()">Close</button>
      </div>
    </div>
  </div>
</div>
<!------------------------------client Authorization--------------------------------------------------------------->

<div *ngIf="EditICD">
  <!--==================================Add and Edit certificate=========================================-->
  <app-client-certificate-edit *ngIf="Editcert " [certificate]="EditCertificateoption"
    (DatafromCertificate)="dataEmitFromCertificate($event)"></app-client-certificate-edit>
</div>
<div *ngIf="EditStartofcare">
  <app-startofcareedit *ngIf="EditSOC" [DataFromSOC]="EditSOCOptions" (BacktoClientSOC)="EventfromSOCEdit($event)">
  </app-startofcareedit>
</div>



<!-- Supervising-Employee Mapping -->
<span id="Supervisingopen" data-bs-toggle="modal" data-bs-target="#Supervisinginfo"></span>
<div class="modal hide fade modalbackgrod" id="Supervisinginfo" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl modal-dialog-scrollable" >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel"> 
          <span >Supervising Provider Mapping</span>
        </h5>
        <button type="button" class="btn-close"  (click)="closeSupervisingMapModel();"></button>
      </div>
      <div class="modal-body">
       <app-supervising-provider-map *ngIf="editSupervisingprovider"></app-supervising-provider-map>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="closeSupervisingMapModel()">Close</button>
      </div>
    </div>
  </div>
</div>
</div>


<!--===============================Add payor required===================================================================-->
<app-payor-required-ids-edit *ngIf="enablepayrate" (IsViewEditpayorequired)="dataEmitpayfromChild($event)"
  [payoRequiredViewEditdata]="payoRequiredViewEdit">
</app-payor-required-ids-edit>

<!----========================= TImesheet Update=========================================================-->
<span data-bs-target="#updateTimesheet" data-bs-toggle="modal" id="update"></span>
<div class="modal fade " id="updateTimesheet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog mw100 " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Update Timesheet</h5>
        <button type="button" class="btn-close" (click)="CloseChildGridModal();clientAuthorizationId=null"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-6">
            <div class="col-lg-12">
              <label class="manualentry-label mr-0 ml-3">Employee
                Name</label>
            </div>
            <div class="col-lg-12">
              <!-- <input type="text" class="form-control" [(ngModel)]="editEmployee" [disabled]="true"> -->
              <ng-select [(ngModel)]="editemployeeId" [searchable]="true" [clearable]="true" [items]="employees"
                class="tdropdown" bindLabel="Value" bindValue="Key" groupBy="type">
                <ng-template ng-optgroup-tmp let-item="item">
                  {{item.type}}
                </ng-template>
              </ng-select>

              
            </div>
          </div>
          <div class="col-lg-6">
            <div class="col-lg-12">
              <label class="manualentry-label mr-0 ml-3">Client
                Name</label>
            </div>
            <div class="col-lg-12">
              <input type="text" class="form-control" [(ngModel)]="editClient" [disabled]="true">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="col-lg-12">
              <label class="manualentry-label mr-0 ml-3">TimeSheet
                Date</label>
            </div>
            <div class="col-lg-12">
              <my-date-picker [options]="myDatePickerOptions" [selDate]="editDate" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="newdates($event,'inputchage','editdate')"
                (dateChanged)="newdates($event,'datechagned','editdate')">
              </my-date-picker>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="col-lg-12">
              <label class="manualentry-label mr-0 ml-3">Service</label>
            </div>
            <div class="col-lg-12">
              <!-- <input type="text" class="form-control" [(ngModel)]="editservice" [disabled]="true"> -->
              <ng-select [(ngModel)]="editservice" [searchable]="true" [clearable]="true" [items]="AuthorizationDetails"
                class="tdropdown" bindLabel="Value" bindValue="Key" (ngModelChange)="getClientAuth()">
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="col-lg-12">
              <label class="manualentry-label mr-0 ml-3">Work
                Hour</label>
            </div>
            <div class="col-lg-12">
              <input type="text" class="form-control" [(ngModel)]="edittime" (keypress)="numberonly($event,'single')">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="col-lg-12">
              <label class="manualentry-label mr-0 ml-3">Timesheet Notes
              </label>
            </div>
            <div class="col-lg-12">
              <textarea class="form-control" [(ngModel)]="editNotes"></textarea>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-12">
              <button class="m-5" class="btn blue-btn ml-3" *ngIf="AuthorizationDetails.length==0"
              (click)="AddClientAuthorization();isNewAuth=true">Add New
              Authorization</button> 
          </div>
      </div>
        <div class="row ml-0">
          <div class="col-lg-12">
              <div class="table-responsive">
                  <table class="table table-hover table-bordered mt-3  ">
                      <thead style="text-align: center;font-size: smaller;">
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;position: relative">
                              Action
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Start Date
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              End Date
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Service
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Description
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Insurance Number#
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Total Units
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Payer Name
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Units Used
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Units Remaining
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Hours Remaining
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Hours/day
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Hours/week
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Remaining Hours/day Based On Last Visit Date
                          </th>

                      </thead>
                      <tbody style="text-align: center;font-size: 12px;">
                          <tr *ngFor="let specifyAuth of AuthorizationDetails;let index=index"
                              [style.backgroundColor]="specifyAuth.isAuthBoolean==true?'lightgray':'white'">
                              <td style="text-align: left;position: relative;">
                                  <button class="btn blue-btn btn-sm ml-1 mr-1" style="font-size:11px"
                                      (click)="selectSpecifyService(specifyAuth)">Select
                                  </button>
                              </td>
                              <td>
                                  {{specifyAuth.startDate| date:'MM/dd/yyyy'}}
                              </td>
                              <td>
                                  {{specifyAuth.endDate| date:'MM/dd/yyyy'}}
                              </td>
                              <td>
                                  {{specifyAuth.masterServiceCode}}
                              </td>
                              <td>
                                  {{specifyAuth.serviceDesc}}
                              </td>
                              <td>
                                  {{specifyAuth.insuranceNo}}
                              </td>
                              <td>
                                  {{specifyAuth.totalUnits}}
                              </td>
                              <td>
                                  {{specifyAuth.payorName}}
                              </td>
                              <td>
                                  {{specifyAuth.unitsUsed}}
                              </td>
                              <td>
                                  {{specifyAuth.unitsRemaining}}
                              </td>
                              <td [style.backgroundColor]="isColorEditValue[index]==true?'yellow':''">
                                  {{specifyAuth.remaingHours}}
                              </td>
                              <td>
                                  {{specifyAuth.hoursPerDay}}
                              </td>
                              <td>
                                  {{specifyAuth.hoursPerWeek}}
                              </td>
                              <td>
                                  {{specifyAuth.hoursPerDayBasedOnLastVisitDate}}
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
              <div *ngIf="AuthorizationDetails.length == 0" class="text-center" style="color:red">
                  <p>No data available</p>
              </div>
          </div>
      </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-lg-6">
            <p class="notealert ml-0"> Note:Date,work Hours & note field only
              editable</p>
          </div>
          <div class="col-lg-6">
            <button class="btn blue-btn" (click)="update()" [disabled]="clientAuthorizationId==0|| clientAuthorizationId==null ||
            editservice==null || editservice==undefined || editservice==''">
              Update & Close
            </button>&nbsp;&nbsp;
            <button class="btn blue-btn" (click)="CloseChildGridModal();clientAuthorizationId=null" data-bs-target="#modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-----------------------------------------------Over All Edit Employee and client----------------------------------------->
<span data-bs-target="#EditClientEmployee" data-bs-toggle="modal" id="editall"></span>
<div class="modal fade " id="EditClientEmployee" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog mw100" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Edit Timesheet</h5>
        <button type="button" class="btn-close" (click)="closeTimes();clientAuthorizationId=null"></button>
      </div>
      <div class="modal-body">
        <div class="row">
         <div class="col-lg-6">
          <div class="col-lg-12">
            <label class="manualentry-label">Employee </label>
          </div>
          <div class="col-lg-12">
            <ng-select [(ngModel)]="editemp" [searchable]="true" [clearable]="true" class="tdropdown"
              [items]="EmployeeDropDown" bindLabel="names" bindValue="id" (ngModelChange)="checkParentUpdateClaim()">
            </ng-select>
          </div>
         </div>
         <div class="col-lg-6">
          <div class="col-lg-12">
            <label class="manualentry-label">Client </label>
          </div>
          <div class="col-lg-12">
            <ng-select [clearable]="true" [searchable]="true" class="tdropdown" [(ngModel)]="editcli"
            [items]="ClientDropDown" (ngModelChange)="checkParentUpdateClaim();getAuthorizationDetails()" bindLabel="names" bindValue="id">
          </ng-select>
          </div>
         </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="col-lg-12">
              <label class="manualentry-label">Service </label>
            </div>
            <div class="col-lg-12">
              <ng-select [(ngModel)]="editserviceoverall" [searchable]="true" [clearable]="true" [items]="AuthorizationDetails"
              (ngModelChange)="checkParentUpdateClaim();" class="tdropdown" bindLabel="Value" bindValue="Key"
              groupBy="type">
              <ng-template ng-optgroup-tmp let-item="item">
                {{item.type}}
              </ng-template>
            </ng-select>
            </div>
           </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-12">
              <button class="m-5" class="btn blue-btn ml-3" *ngIf="AuthorizationDetails.length==0"
              (click)="AddClientAuthorization();isNewAuth=true">Add New
              Authorization</button> 
          </div>
      </div>
      <div class="row ml-0">
          <div class="col-lg-12">
              <div class="table-responsive">
                  <table class="table table-hover table-bordered mt-3  ">
                      <thead style="text-align: center;font-size: smaller;">
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;position: relative">
                              Action
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Start Date
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              End Date
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Service
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Description
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Insurance Number#
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Total Units
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Payer Name
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Units Used
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Units Remaining
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Hours Remaining
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Hours/day
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Hours/week
                          </th>
                          <th class="pointer ttablehead"
                              style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                              Remaining Hours/day Based On Last Visit Date
                          </th>

                      </thead>
                      <tbody style="text-align: center;font-size: 12px;">
                          <tr *ngFor="let specifyAuth of AuthorizationDetails;let index=index"
                              [style.backgroundColor]="specifyAuth.isAuthBoolean==true?'lightgray':'white'">
                              <td style="text-align: left;position: relative;">
                                  <button class="btn blue-btn btn-sm ml-1 mr-1" style="font-size:11px"
                                      (click)="selectSpecifyService(specifyAuth)">Select
                                  </button>
                              </td>
                              <td>
                                  {{specifyAuth.startDate| date:'MM/dd/yyyy'}}
                              </td>
                              <td>
                                  {{specifyAuth.endDate| date:'MM/dd/yyyy'}}
                              </td>
                              <td>
                                  {{specifyAuth.masterServiceCode}}
                              </td>
                              <td>
                                  {{specifyAuth.serviceDesc}}
                              </td>
                              <td>
                                  {{specifyAuth.insuranceNo}}
                              </td>
                              <td>
                                  {{specifyAuth.totalUnits}}
                              </td>
                              <td>
                                  {{specifyAuth.payorName}}
                              </td>
                              <td>
                                  {{specifyAuth.unitsUsed}}
                              </td>
                              <td>
                                  {{specifyAuth.unitsRemaining}}
                              </td>
                              <td [style.backgroundColor]="isColorEditValue[index]==true?'yellow':''">
                                  {{specifyAuth.remaingHours}}
                              </td>
                              <td>
                                  {{specifyAuth.hoursPerDay}}
                              </td>
                              <td>
                                  {{specifyAuth.hoursPerWeek}}
                              </td>
                              <td>
                                  {{specifyAuth.hoursPerDayBasedOnLastVisitDate}}
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
              <div *ngIf="AuthorizationDetails.length == 0" class="text-center" style="color:red">
                  <p>No data available</p>
              </div>
          </div>
      </div>

      </div>
      <div class="modal-footer">
        <!---->
        <button type="button" class="btn blue-btn" [disabled]="editcli==null||editcli==undefined||
          editemp==undefined||editemp==null || editserviceoverall==undefined||editserviceoverall==null ||
          clientAuthorizationId==0|| clientAuthorizationId==null || clientAuthorizationId==undefined
         " (click)="editTotaltimesheet()">Update & Close</button>
        <button type="button" class="btn blue-btn" (click)="closeTimesheet();clientAuthorizationId=null" data-bs-target="#modal">Cancel</button>
      </div>
    </div>
  </div>
</div>


<!-- Move Archive Notes -->
<span id="openArchiveNotes" data-bs-toggle="modal" data-bs-target="#modalArchiveNotes"></span>
<div class="modal hide fade modalbackgrod" id="modalArchiveNotes" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog  ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Reason</h5>
        <button type="button" class="btn-close" (click)="closeReason()"></button>
      </div>
      <div class="modal-body ">
        <div class="row">
          <div class="col-lg-4">
            <label class="mt-4">Reason<sup class="super-script mr-1 ">*</sup></label>
          </div>
          <div class="col-lg-6">
            <textarea class="form-control" style="width: 249px;height: 72px;" [(ngModel)]="Archievenotes">
                        </textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" (click)="TimeSheetVerificationArchive()" [disabled]="Archievenotes==null||
        Archievenotes==undefined||Archievenotes==''|| disabledNotes"><span>Save</span>
        </button>
        <button type="button" class="btn blue-btn btn-sm" (click)="closeReason()">Close</button>
      </div>
    </div>
  </div>
</div>

<span id="OpenNotesReasonModal" data-bs-target="#shownotes" data-bs-toggle="modal"></span>
<div class="modal fade" id="shownotes" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">

  <div class="modal-dialog " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <label class="font-header">Reason</label>

        <button type="button" class="btn-close" (click)="closeNotesReason()"></button>
      </div>
      <div class="modal-body">
        <div class="container ">
          <div class="col-lg-12">
            <textarea class="form-control" style="max-width: 430px;height: 72px;" [(ngModel)]="Reasonforarchive"
              disabled>
                        </textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="EditAuthorization">
  <app-client-authorization-edit *ngIf="EditAuthorization" (EventToEditAuth)="dataEmitfromChild($event)"
    [DataFromAuthorizationList]="authinput">
  </app-client-authorization-edit>
</div>
